import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import Card from '../Card/Card.js';
import Price from '../Price/Price.js';

const PriceComponent = ({ priceIsZeroLabel , discountText , originalPrice , discountedPrice , currency ,  })=>{
    if (originalPrice === 0) {
        return /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "caption"
        }, priceIsZeroLabel);
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "caption"
        }, discountText);
    }
    const isDiscounted = isNumber(discountedPrice);
    return /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption",
        className: "line-item-bundle-row__price"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: isDiscounted ? discountedPrice : originalPrice,
        currency: currency
    }), isDiscounted ? /*#__PURE__*/ React.createElement(Price, {
        type: "strikethrough",
        currency: currency,
        value: originalPrice
    }) : null);
};
var LineItemBundleRow = (props)=>{
    const { title , body  } = props, priceInfo = swcHelpers.objectWithoutProperties(props, [
        "title",
        "body"
    ]);
    const { getLabel  } = useIntl();
    const priceIsZeroLabel = priceInfo.priceIsZeroLabel || getLabel('cart.lineItem.glasses.isIncluded', {
        hideLabelKey: true
    });
    return /*#__PURE__*/ React.createElement(Card.Section, {
        className: "line-item-bundle-row__section"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none"
    }, title && /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption-head"
    }, title), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption"
    }, body)), /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none"
    }, /*#__PURE__*/ React.createElement(PriceComponent, swcHelpers.extends({}, priceInfo, {
        priceIsZeroLabel: priceIsZeroLabel
    }))));
};

export { LineItemBundleRow };
//# sourceMappingURL=LineItemBundleRow.js.map
